export const AUTH_TOKEN_STORAGE_KEY = 'auth_token'
export const USER_PROFILE_STORAGE_KEY = 'user_profile'
export const ARTIST_STORAGE_KEY = 'artist'
export const ARTIST_NOTIFICATIONS = window.SITE_CONFIG.ARTIST_NOTIFICATIONS || []
export const RECAPTCHA_SITE_KEY = window.SITE_CONFIG.RECAPTCHA_SITE_KEY



// WEBPACK FOOTER //
// ./src/constants/index.js